const hitungSablon = (panjang, lebar) => {
  const newPanjang =
    Number(panjang) >= Number(lebar) ? Number(panjang) : Number(lebar);
  const luas = Number(panjang) * Number(lebar);

  if (luas <= 0 || typeof luas !== "number") {
    return 0;
  } else if (luas <= 100) {
    return 15000;
  } else if (luas <= 200) {
    return 20000;
  } else if (luas <= 311) {
    return 25000;
  } else if (luas <= 485) {
    return 30000;
  } else if (luas <= 623) {
    return 35000;
  } else if (luas <= 875) {
    return 40000;
  } else if (luas <= 1240) {
    return 45000;
  } else if (luas <= 1475) {
    return 50000;
  } else if (Number(newPanjang) > 199) {
    return Number(newPanjang) * 1000 - 10000;
  } else if (Number(newPanjang) > 94) {
    return Number(newPanjang) * 1000 - 5000;
  } else if (Number(newPanjang) > 50) {
    return Number(newPanjang) * 1000;
  }
};

export default hitungSablon;
